import React from 'react';

import { StatusIconCellProps } from '../../../../../types/FieldNomsSwingContract.type';
import { isFieldActive } from '../../../../../utils/common/utils';
import { StatusIcon } from '../style';

const StatusIconCell: React.FC<StatusIconCellProps> = ({
  validFrom,
  validTo,
}) => {
  const isActive = isFieldActive(validFrom, validTo);
  return (
    <StatusIcon
      width={20}
      height={20}
      src={isActive ? '/check-green.png' : '/cross-red.png'}
      alt={isActive ? 'Active' : 'Inactive'}
      title={isActive ? 'Active' : 'Inactive'}
    />
  );
};

export default StatusIconCell;
